import React from "react";
import ProgressBar from "react-bootstrap/ProgressBar";
import "./style.scss";
import Cookies from "js-cookie";
import { Button, Image } from "react-bootstrap";
import { ThreeDotsDropdown } from "..";
import { Link } from "react-router-dom";

const PageTitleHeader = (props) => {
  const {
    title,
    extraClass,
    subTitle,
    mobileTitle,
    isArrow,
    onClick,
    progress,
    rightBtnHandler,
    rightBtn,
    rightBtnText,
    rightBtnStyle,
    leftBtnHandler,
    leftBtn,
    leftBtnText,
    threeDotNav,
    setDeactivateReasonOptions,
    relistingProperty,
    setSharedListing,
    setSharedAnalytics,
    saveLoading,
    status,
    propertyId,
    propertyDetailsId,
    showRelist
  } = props;
  const role = Number(Cookies.get("role"));

  const onDeactivateListing = () => {
    setDeactivateReasonOptions(true);
  }

  const onShareListing = () => {
    setSharedListing(true);
  }

  const onShowAnalytics = () => {
    setSharedAnalytics(true)
  }

  return (
    <React.Fragment>
      <div className={`${role !== 1 ? "profile-header" : extraClass === "leaseInfoTitle" ? 'profile-header changes leaseInfoTitleContainer' : "profile-header changes"}`}>
        <div className="d-flex justify-content-start align-items-center">
          {isArrow && (
            <div
              className={
                role !== 1
                  ? "profile-header-image"
                  : `profile-header-image mr-2 ${extraClass}`
              }
              onClick={onClick}
            >
              <img
                alt="arrowVector"
                src={require("../../../_assets/images/arrowVector.png")}
                width={role !== 1 || extraClass ? "24" : "18"}
                height={role !== 1 || extraClass ? "21" : "13"}
                className={
                  role !== 1 || extraClass
                    ? "d-inline-block align-top"
                    : "d-inline-block align-top mt-2"
                }
              />
            </div>
          )}
          <div className={role !== 1 ? "profile-name" : "profile-name changes"}>
            <span className={"img-dt-title navbar-brand-name " + extraClass}>
              {title}
            </span>
            {status && <div className={`header-status ${status}`}>{status}</div>}

            <span className="img-mb-title navbar-brand-name">{mobileTitle}</span>
            {subTitle && (
              <div>
                <span className="img-dt-subtitle" style={{ display: "block" }}>
                  {subTitle}
                </span>
              </div>
            )}
          </div>
        </div>
        {leftBtn === "true" && (
          <Button onClick={leftBtnHandler} className="left-Btn page-header-left-button">
            {leftBtnText}{saveLoading === true && <i className='fa fa-spinner fa-spin ml-2'></i>}
          </Button>
        )}
        {rightBtn === "true" && (
          <Button onClick={rightBtnHandler} className="right-Btn page-header-right-button" style={{ ...rightBtnStyle }} variant="success">
            <div> 
            {rightBtnText}
            </div>

          </Button>
        )}

        {(threeDotNav === 'property-details') &&
          <ThreeDotsDropdown
            icon={<Image
              width="6px"
              height="24px"
              alt="three-dots-vertical"
              src={require(`../../../_assets/images/three-dots-vertical.svg`)} />}
            actionsButton={
              <>
                <>
                  <div className="dropdown-item cursor-pointer" onClick={() => onDeactivateListing()}>Deactivate Listing</div>
                  <div className="dropdown-item cursor-pointer" onClick={() => onShareListing()}>Share Listing</div>
                  <div className="dropdown-item cursor-pointer" onClick={() => onShowAnalytics()}>Show analytics</div>
                </>
              </>
            }
          />}

        {(threeDotNav === 'property-relist') &&
          <ThreeDotsDropdown
            icon={<Image
              width="6px"
              height="24px"
              alt="three-dots-vertical"
              src={require(`../../../_assets/images/three-dots-vertical.svg`)} />}
            actionsButton={
              <>
                {showRelist && <div className="dropdown-item cursor-pointer" onClick={relistingProperty}>
                  Relist Listing
                </div>}
                <div className="dropdown-item cursor-pointer">
                  <Link style={{ textDecoration: 'none', color: '#212529' }} to={`/create-notice/${propertyId}/${propertyDetailsId}`}>End The Tenancy</Link>
                </div>
              </>
            }
        />}

        {props.extraElm && <>{props.extraElm}</>}
      </div>

      <div className="progress-bar-outer">
        {progress && <ProgressBar now={progress} />}
      </div>
    </React.Fragment>
  );
};

export default PageTitleHeader;
